import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ISelectionItem } from 'src/app/common/contracts/components/selection-item';
import { SelectionItem } from 'src/app/shared/models/selectionItem';

@Component({
  selector: 'swodoc-node-dropdown',
  templateUrl: 'swodoc-node-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeDropdown {
  @Input()
  node: any;
  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();

  get selectionItems(): ISelectionItem[] {
    if (this.node && this.node.selectables && this.node.selectables.length) {
      const selectionItems: ISelectionItem[] = [];
      for (const item of this.node.selectables) {
        selectionItems.push(new SelectionItem(item.label, item.label));
      }
      return selectionItems;
    }
    return [];
  }

  get value(): string {
    if (this.node.responses && this.node.responses.length > 0 && this.node.responses[0].value) {
      return this.node.responses[0].value;
    }

    return '';
  }
  set value(value: string) {
    this.node.responses = this.node.responses || [];
    if (this.node.responses.length === 0) {
      this.node.responses.push({ value });
    } else {
      this.node.responses[0] = { value };
    }
    this.changed.emit(this.node);
  }
}
